import { FreshSurveyTextType } from './types';

export const EN: FreshSurveyTextType = {
  settings: {
    heading: 'sidebar.settings',
    description: '',
    accountinfo: {
      layout: {
        description: 'settings.account_info.description',
        heading: 'settings.account_info.heading',
      },
    },
    translationsettings: {
      layout: {
        description: 'settings.translation_settings.description',
        heading: 'settings.translation_settings.heading',
      },
    },
    blockedSentimentTopic: {
      layout: {
        description: 'settings.blocked_sentiment_topic.description',
        heading: 'settings.blocked_sentiment_topic.heading',
      },
    },
    savedtemplates: {
      layout: {
        description: 'settings.saved_templates.layout.description',
        heading: 'settings.saved_templates.layout.heading',
      },
      action: {
        okButton: 'settings.saved_templates.action.okButton',
      },
      fields: {
        search: {
          placeholder: 'settings.saved_templates.fields.search.placeholder',
        },
        empty: {
          name: 'settings.saved_templates.fields.empty.name',
          hint: 'settings.saved_templates.fields.empty.hint',
        },
        columnSurvey: {
          name: 'contacts.import_contact.placeholder_headers.survey',
        },
        columnTheme: {
          name: 'settings.saved_templates.fields.columnTheme.name',
        },
        columnCrOn: {
          name: 'settings.saved_templates.fields.columnCrOn.name',
        },
        columnCrBy: {
          name: 'settings.saved_templates.fields.columnCrBy.name',
        },
      },
    },
    designThemes: {
      layout: {
        description: 'settings.design_themes.layout.description',
        heading: 'settings.design_themes.layout.heading',
      },
      fields: {
        empty: {
          name: 'settings.design_themes.fields.empty.name',
        },
      },
    },
    blocklist: {
      layout: {
        description: '',
        heading: 'settings.blocklist.layout',
      },
    },
    customdomainmapping: {
      layout: {
        description: 'settings.custom_domain.description',
        heading: 'settings.custom_domain.title',
      },
    },
    customfields: {
      layout: {
        description: 'settings.custom_fields.layout.description',
        heading: 'settings.custom_fields.layout.heading',
        unload: 'settings.custom_fields.layout.unload',
        error: 'empty_state.message.network_error',
      },
      action: {
        okButton: 'settings.custom_fields.action.okButton',
      },
      fields: {
        newField: {
          name: 'settings.custom_fields.fields.newField.name',
        },
        newOption: {
          name: 'settings.custom_fields.fields.newOption.name',
        },
        fieldId: {
          error: 'forms.err_msg.field_name_required',
        },
        fieldName: {
          error: 'forms.err_msg.field_name_required',
        },
        newChoice: {
          name: 'settings.custom_fields.fields.newChoice.name',
        },
        addOptions: {
          name: 'settings.custom_fields.fields.addOptions.name',
        },
        fieldType: {
          name: 'settings.custom_fields.fields.fieldType.name',
        },
        default: {
          name: 'settings.custom_fields.default',
        },
        required: {
          name: 'required',
        },
        buttonEdit: {
          name: 'edit',
        },
        buttonDelete: {
          name: 'delete',
        },
        buttonReset: {
          name: 'reset',
        },
      },
    },
    dkimsettings: {
      layout: {
        description: '',
        heading: 'settings.dkim_settings.heading',
      },
    },
    integrations: {
      layout: {
        description: '',
        heading: 'settings.integrations.layout.heading',
      },
    },
    profile: {
      layout: {
        description: '',
        heading: 'profile.title',
      },
    },
    surveylimit: {
      layout: {
        description: 'settings.global_survey_limit.description',
        heading: 'settings.global_survey_limit.title',
      },
      misc: {
        details: 'settings.global_survey_limit.misc.details',
        link: 'settings.global_survey_limit.misc.link',
      },
      fields: {
        triggers: {
          name: 'settings.global_survey_limit.fields.name',
          helper: 'settings.global_survey_limit.fields.helper',
        },
        limitReset: {
          name: 'settings.global_survey_limit.limitReset.name',
        },
        surveyed: {
          name: 'settings.global_survey_limit.surveyed.name',
          helper: 'settings.global_survey_limit.surveyed.helper',
        },
        section1: {
          name: 'settings.global_survey_limit.section1',
        },
        section2: {
          name: 'settings.global_survey_limit.section2',
        },
        generate: {
          name: 'settings.global_survey_limit.generate.name',
          helper: 'settings.global_survey_limit.generate.helper',
        },
      },
      action: {
        okButton: 'settings.global_survey_limit.action.okButton',
        cancelButton: 'settings.global_survey_limit.action.cancelButton',
      },
    },
    tags: {
      layout: {
        description: '',
        heading: 'settings.tags.title',
      },
    },
    user: {
      layout: {
        description: 'settings.user_management.description',
        heading: 'settings.user_management.title',
      },
      action: {
        okButton: 'settings.user_management.buttons.invite_user',
      },
      fields: {
        search: {
          name: 'settings.user_management.fields.search.name',
        },
        tabAll: {
          name: 'settings.user_management.fields.tabAll.name',
        },
        tabPending: {
          name: 'settings.user_management.fields.tabPending.name',
        },
        roleAdmin: {
          name: 'settings.user_management.fields.roleAdmin.name',
          hint: 'settings.user_management.fields.roleAdmin.hint',
        },
        roleOwner: {
          name: 'settings.user_management.fields.roleOwner.name',
        },
        roleAnalyst: {
          name: 'settings.user_management.fields.roleAnalyst.name',
          hint: 'settings.user_management.fields.roleAnalyst.hint',
        },
        roleViewer: {
          name: 'settings.user_management.fields.roleViewer.name',
          hint: 'settings.user_management.fields.roleViewer.hint',
        },
        colName: {
          name: 'name',
        },
        colEmail: {
          name: 'email',
        },
        colWeekly: {
          name: 'settings.user_management.fields.colWeekly.name',
          successMessage:
            'settings.user_management.fields.colWeekly.successMessage',
          warningMessage:
            'settings.user_management.fields.colWeekly.warningMessage',
          failureMessage:
            'settings.user_management.fields.colWeekly.failureMessage',
        },
        colMonthly: {
          name: 'settings.user_management.fields.colMonthly.name',
          successMessage:
            'settings.user_management.fields.colMonthly.successMessage',
          warningMessage:
            'settings.user_management.fields.colMonthly.warningMessage',
          failureMessage:
            'settings.user_management.fields.colMonthly.failureMessage',
        },
        colRole: {
          name: 'settings.user_management.fields.colRole.name',
        },
        colStatus: {
          name: 'contacts.import_contact.default_fields.contact.status',
        },
        colLast: {
          name: 'settings.user_management.fields.colLast.name',
        },
        inviteUserForm: {
          name: 'settings.user_management.fields.inviteUserForm.name',
          okButton: 'settings.user_management.fields.inviteUserForm.okButton',
          cancelButton: 'cancel',
        },
        selectRole: {
          name: 'settings.user_management.fields.selectRole.name',
        },
        userEmails: {
          name: 'settings.user_management.fields.userEmails.name',
          hint: 'settings.user_management.fields.userEmails.hint',
          placeholder: 'settings.user_management.fields.userEmail.placeholder',
        },
        remaining: {
          name: 'settings.user_management.fields.remaining.name',
        },
        weekly: {
          name: 'settings.user_management.fields.weekly.name',
        },
        monthly: {
          name: 'settings.user_management.fields.monthly.name',
        },
        statusActive: {
          name: 'responses.filter_condition.survey_state.active',
        },
        statusInActive: {
          name: 'responses.filter_condition.survey_state.inactive',
        },
        statusPending: {
          name: 'pending',
        },
        optionDelete: {
          name: 'delete',
        },
        optionResend: {
          name: 'settings.user_management.fields.optionResend.name',
        },
        optionDeactivate: {
          name: 'contacts.menu.deactivate.text',
        },
        optionActivate: {
          name: 'contacts.menu.activate.text',
        },
        confirmation: {
          name: 'settings.user_management.fields.confirmation.name',
          okButton: 'delete',
          cancelButton: 'cancel',
          hint: 'settings.user_management.fields.confirmation.hint',
        },
      },
    },
  },
};

export const getText: (language: 'EN') => FreshSurveyTextType = (language) => {
  switch (language) {
    case 'EN':
      return EN;
    default:
      return EN;
  }
};
